import React from 'react';

const UserRights = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        You have the following rights regarding your data:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>Access your personal information</li>
        <li>Request corrections to your data</li>
        <li>Delete your account and associated data</li>
      </ul>
    </div>
  );
};

export default UserRights;